export default "__VITE_ASSET__B8k0XFCG__"